import {
    Button, Grid, Paper, Stack,
} from "@mui/material";
import {Email} from "@mui/icons-material";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {useTheftMisappropriationActions} from "../../../../service/useTheftMisappropriationActions";
import {Typography} from "@mui/material";
import EmptyState from "../../../../../../util/component/EmptyState";
import NewMessageModal from "../../modals/NewMessageModal";
import dayjs from "dayjs";
import {useHasScope} from "../../../../../../config/globalConfig";
import {THEFT_MISAPPROPRIATION_SCOPE_MESSAGES} from "../../../../component/utils/AuthConstants";

const TabMessages = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const [createMessageModal, setCreateMessageModal] = useState(false);
    const [messages, setMessages] = useState([]);
    const [listShouldUpdate, setListShouldUpdate] = useState(false);
    const {getMessages} = useTheftMisappropriationActions();
    const hasScope = useHasScope;
    useEffect(() => {
        // retrieve messages
        retrieveMessages();
    }, [])

    const retrieveMessages = () => {
        getMessages(props.idTheftMisappropriation).then(res => {
            setMessages(res.result);
        });
    }

    useEffect(() => {
        if (listShouldUpdate) {
            // retrieve messages
            retrieveMessages();
            setListShouldUpdate(false);
        }
    }, [listShouldUpdate])

    return (
        <>
            <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "25px"}}>
                <Grid xs={12} item container justifyContent={"flex-end"}>
                    {hasScope(THEFT_MISAPPROPRIATION_SCOPE_MESSAGES) &&
                        <Stack direction={"row"} alignItems={"center"}>
                            <Button
                                onClick={(event) => {
                                    setCreateMessageModal(true);
                                }}>
                                <Email/> {t("message.newMessage")}
                            </Button>
                        </Stack>}
                </Grid>
                <Grid xs={12} item container justifyContent={"center"}>
                    <Grid item xs={12}>
                        <Paper elevation={3} style={{minHeight: "190px"}}>
                            <Grid item container xs={12} justifyContent={"center"} sx={{padding: "16px 16px 0 16px"}}>
                                {messages.length > 0 ?
                                    messages.map((msg: any) => (
                                        <Grid item container xs={12} sx={{paddingBottom: "16px"}}>
                                            <Paper elevation={2}
                                                   sx={{width: "100%", backgroundColor: "#FAFBFF"}}>
                                                <Grid item container xs={12} sx={{padding: "10px"}}>
                                                    <Grid item container xs={12} justifyContent={"flex-end"}>
                                                        <Stack direction={"row"} alignItems={"center"}>
                                                            <Typography fontFamily={"Tahoma"} fontStyle={"normal"}
                                                                        fontWeight={"700"} fontSize={"16px"}
                                                                        lineHeight={"140%"}
                                                                        letterSpacing={"-0.01em"}>{dayjs(msg.createDatetime).format("lll")}</Typography>
                                                        </Stack>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Stack
                                                            direction="row"
                                                            justifyContent="flex-start"
                                                            alignItems="center"
                                                            spacing={2}
                                                        >

                                                            <Typography style={{width: "70px"}} fontFamily={"Raleway"}
                                                                        fontStyle={"normal"}
                                                                        fontWeight={"500"} fontSize={"16px"}
                                                                        lineHeight={"140%"}
                                                                        letterSpacing={"-0.01em"}
                                                                        display="inline">{t("message.to") + ": "}</Typography>
                                                            <Typography fontFamily={"Raleway"} fontStyle={"normal"}
                                                                        fontWeight={"700"} fontSize={"16px"}
                                                                        lineHeight={"140%"}
                                                                        letterSpacing={"-0.01em"}
                                                                        display="inline">{msg.recipients.length > 0 ? msg.recipients.join("; ") : ""}</Typography>
                                                        </Stack>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Stack
                                                            direction="row"
                                                            justifyContent="flex-start"
                                                            alignItems="center"
                                                            spacing={2}
                                                        >
                                                            <Typography style={{width: "70px"}} fontFamily={"Raleway"}
                                                                        fontStyle={"normal"}
                                                                        fontWeight={"500"} fontSize={"16px"}
                                                                        lineHeight={"140%"}
                                                                        letterSpacing={"-0.01em"}
                                                                        display="inline">{t("message.subject") + ": "}</Typography>
                                                            <Typography fontFamily={"Raleway"} fontStyle={"normal"}
                                                                        fontWeight={"700"} fontSize={"16px"}
                                                                        lineHeight={"140%"}
                                                                        letterSpacing={"-0.01em"}
                                                                        display="inline">{msg.subject}</Typography>
                                                        </Stack>
                                                    </Grid>
                                                    <Grid item xs={12} sx={{paddingTop: "5px"}}>
                                                        <Typography fontFamily={"Tahoma"} fontStyle={"normal"}
                                                                    fontWeight={"400"} fontSize={"16px"}
                                                                    lineHeight={"190%"}
                                                                    style={{opacity: "0.6"}}>{msg.message}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        </Grid>))
                                    :
                                    <Grid item xs={3} paddingTop={5}>
                                        <EmptyState title={t("message.noMessageTitle")}
                                                    content={hasScope(THEFT_MISAPPROPRIATION_SCOPE_MESSAGES) ? t("message.noMessageDescription") : ""}/>
                                    </Grid>
                                }</Grid>
                        </Paper>
                    </Grid>
                </Grid>

            </Grid>
            {hasScope(THEFT_MISAPPROPRIATION_SCOPE_MESSAGES) && createMessageModal && <NewMessageModal open={createMessageModal} handleClose={() => setCreateMessageModal(false)}
                             idTheftMisappropriation={props.idTheftMisappropriation} eventTypeCode={props.eventTypeCode}
                             plate={props.plate} tenant={props.tenant} dealer={props.dealer}
                             setListShouldUpdate={setListShouldUpdate}/>}
        </>
    );
}

export default TabMessages;